import { useAppSelector } from '@hooks/app/redux';
import { getProviderMerchants } from '@services/external/software-provider.api';
import { useQuery, UseQueryOptions } from 'react-query';
import { TMyMerchantSearchParams } from 'types/software-provider.types';

async function handler(providerId: string, params?: TMyMerchantSearchParams) {
  const { data } = await getProviderMerchants(providerId, params);
  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useMySoftwareProviders(
  params: TMyMerchantSearchParams = {},
  options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useQuery(
    ['softwareProvider:myProviders', params, providerId],
    () => handler(providerId, params),
    options,
  );
}

export default useMySoftwareProviders;
